import { render, staticRenderFns } from "./cardTable.vue?vue&type=template&id=92cb58cc&"
import script from "./cardTable.vue?vue&type=script&lang=js&"
export * from "./cardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports